import {StyleSheet, View, TouchableWithoutFeedback} from 'react-native';
import Styles from '../../Styles';
import AVText from '../AVText';
import {getDescriber as getSnackDescriber} from 'src/components/screens/sendSnack/descriptor/sendasnack/DescriptorType';
import {RewardProductType} from 'src/types/Rewards';
import {ensureHttps} from 'src/services/StringUtils';
import {RewardsIcon} from 'src/components/img/svg/rewards';
import {ImageWithPlaceholder} from 'src/components/elements/rewards/RedeemPoints4Rewards';
import {RewardTier} from 'src/types/RewardsModel';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';

type ProductRewardTileProps = {
  rewardItem: RewardProductType;
  tier: RewardTier;
  onRewardPress: (item: RewardProductType, pointsRequired: number) => void;
};
const lineHeightMultiplier = 1.14;
export default function ProductRewardTile(props: ProductRewardTileProps) {
  const {rewardItem, tier, onRewardPress} = props;
  return (
    <TouchableWithoutFeedback
      onPress={() => {
        !tier.isLocked && onRewardPress(rewardItem, tier.pointsRequired);
      }}
    >
      <View
        style={styles.tile}
        accessible
        testID="qa_btn_RewardsItem"
        nativeID="qa_btn_RewardsItem"
      >
        <View
          accessibilityRole="button"
          accessibilityLabel={rewardItem.name}
          style={[styles.productItem, tier.isLocked && styles.disabled]}
        >
          <ImageWithPlaceholder
            source={{uri: ensureHttps(rewardItem?.imageUrl || '')}}
            width={67}
            height={67}
          >
            <RewardsIcon />
          </ImageWithPlaceholder>

          <AVText
            numberOfLines={3}
            maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm2}
            style={[
              styles.productName,
              getSnackDescriber()?.snackDetailsBtnFontSTyle(),
              {
                textAlign: 'center', // Ensure the text is centered
              },
            ]}
          >
            {rewardItem?.name}
          </AVText>
        </View>
      </View>
    </TouchableWithoutFeedback>
  );
}
const styles = StyleSheet.create({
  productItem: {
    width: 164,
    height: 170,
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 12,
    paddingHorizontal: Styles.Spacing.m3 - 4,
    paddingTop: Styles.Spacing.m3,
    paddingBottom: Styles.Spacing.m4,
  },
  productName: {
    width: '100%',
    flexGrow: 1,
    textAlign: 'center',
    fontSize: Styles.Fonts.f1 - 2,
    fontWeight: '700',
    lineHeight: (Styles.Fonts.f1 - 3) * lineHeightMultiplier,
    marginTop: Styles.Spacing.m0,
  },
  disabled: {
    opacity: 0.6,
  },
  tile: {
    width: 164,
    height: 170,
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 12,
    paddingHorizontal: Styles.Spacing.m3 - 4,
    paddingBottom: Styles.Spacing.m4,
    borderRadius: 14,
    ...getLayoutDescriber().shadowStyles().lightShadow,
  },
});
